document.addEventListener('DOMContentLoaded', () => {
  const dropArea = document.getElementById('drop-area');
  const fileInput = document.getElementById('file-upload');
  const resultDiv = document.getElementById('result');
  const loadingSpinner = document.getElementById('loading-spinner');
  let selectedFile = null;
  let uploaded = false;

  if (!dropArea || !fileInput) {
    return;
  }

  function showSpinner() {
    if (loadingSpinner) {
      loadingSpinner.style.setProperty('display', 'flex', 'important');
      loadingSpinner.style.setProperty('visibility', 'visible', 'important');
      loadingSpinner.style.setProperty('opacity', '1', 'important');
      loadingSpinner.style.setProperty('z-index', '99999', 'important');
    }
  }

  function hideSpinner() {
    if (loadingSpinner) {
      loadingSpinner.style.setProperty('display', 'none', 'important');
      loadingSpinner.style.setProperty('visibility', 'hidden', 'important');
      loadingSpinner.style.setProperty('opacity', '0', 'important');
    }
  }

  hideSpinner();
  function uploadFile() {
    if (!selectedFile) {
      alert('Please select a file first.');
      return;
    }

    const url = 'https://api.cloudinary.com/v1_1/drjqqcxeg/image/upload';
    const preset = 'xwallx';
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('upload_preset', preset);

    showSpinner();
    if (resultDiv) resultDiv.textContent = 'Uploading...';

    fetch(url, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.secure_url) {
        hideSpinner();
        uploaded = true;
        if (resultDiv) resultDiv.innerHTML = `Uploaded successfully! <a href="${data.secure_url}" target="_blank">View Image</a>`;
        dropArea.classList.add('disabled');
        document.querySelectorAll('product-modal[open]').forEach((m) => m.hide());
        const script = document.createElement('script');
        script.src = "{{ 'product-modal.js' | asset_url }}";
        script.defer = true;
        document.body.appendChild(script);
        const newImageUrl = data.secure_url;

        const mainImage = document.querySelector('.product__media img');
        if (mainImage) {
          mainImage.src = newImageUrl;
          mainImage.srcset = '';
          mainImage.alt = 'artwork';
        }

        document.querySelectorAll('.product-media-modal img').forEach((modalImage) => {
          modalImage.src = newImageUrl;
          modalImage.srcset = '';
          modalImage.alt = 'artwork';
        });

        const canvasImage = document.getElementById('c-canvas');
        if (canvasImage) {
          const ctx = canvasImage.getContext('2d');
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = () => {
            ctx.clearRect(0, 0, canvasImage.width, canvasImage.height);
            ctx.drawImage(img, 0, 0, canvasImage.width, canvasImage.height);
          };
          img.src = newImageUrl;
        }

        const productInfo = document.querySelector('.product__info-wrapper');
        if (productInfo) {
          productInfo.style.display = 'block';
        }

      } else {
        hideSpinner();
        if (resultDiv) resultDiv.textContent = 'Upload failed.';
      }
    })
    .catch(err => {
      hideSpinner();
      if (resultDiv) resultDiv.textContent = 'An error occurred.';
      console.error(err);
    });
  }

  dropArea.addEventListener('click', (e) => {
    if (uploaded) return;
    e.stopPropagation();
    fileInput.click();
  }, true);

  fileInput.addEventListener('change', (e) => {
    if (uploaded) return;
    selectedFile = e.target.files[0];
    const p = dropArea.querySelector('p');
    if (p && selectedFile) p.textContent = selectedFile.name;
    uploadFile();
  });

  dropArea.addEventListener('dragover', (e) => {
    e.preventDefault();
    dropArea.classList.add('dragover');
  });

  dropArea.addEventListener('dragleave', () => {
    dropArea.classList.remove('dragover');
  });

  dropArea.addEventListener('drop', (e) => {
    e.preventDefault();
    if (uploaded) return;
    dropArea.classList.remove('dragover');
    selectedFile = e.dataTransfer.files[0];
    const p = dropArea.querySelector('p');
    if (p && selectedFile) p.textContent = selectedFile.name;
    uploadFile();
  });
});